<template>
  <div class="login-wrap">
    <div v-if="authType === 'adfs'" class="login signup-box adfs text-center animated fadeInDown">
      <div class="login-panel login active">
        <form v-on:submit.prevent>
          <div class="login-logo">
            <img alt="image" class="" src="static/img/logo_nav.png" />
          </div>
          <div @click="loginByIdp" class="login-btnset"><button class="btn btn-success block m-b">{{$t('loginString')}}</button></div>
          <b-button-group>
            <b-button @click="changeLanguage('ja')"><img class="flag" :src="'static/img/flag/flag_japan.png'" alt="">日本語 <small>{{$t('transLanguage.ja')}}</small></b-button>
            <b-button @click="changeLanguage('en')"><img class="flag" :src="'static/img/flag/flag_usa.png'" alt="">English <small>{{$t('transLanguage.en')}}</small></b-button>
            <b-button @click="changeLanguage('zh_tr')"><img  class="flag" :src="'static/img/flag/flag_china.png'" alt="">繁體中文 <small>{{$t('transLanguage.ch')}}</small></b-button>
         </b-button-group>
        </form>
      </div>
    </div>

    <div v-else class="flex-box signup-box">
      <div class="login-panel animated fadeInDown login" :class="{'active' : signUp}">
        <transition v-if="signUp" name="fade">
          <form v-on:submit.prevent="login">
            <div class="login-logo">
              <img alt="image" class="" src="static/img/logo_nav.png" />
            </div>
            <div class="form-group text-left">
              <label class="control-label">{{$t('idLabel')}}</label>
              <input type="text" v-model="email" class="form-control" :placeholder="$t('placeholderMailString')">
            </div>
            <div class="form-group text-left">
              <label class="control-label">{{$t('placeholderPasswordString')}}</label>
              <input type="password" v-model="password" class="form-control" :placeholder="$t('placeholderPasswordString')">
            </div>
            <p class="text-muted text-left"><small><router-link :to="{ name: 'Reset' }">{{$t('forgetPasswordString')}}</router-link></small></p>
            <div class="login-btnset"><button type="submit" class="btn btn-success block m-b">{{$t('loginString')}}</button></div>
            <b-button-group>
              <b-button @click="changeLanguage('ja')"><img class="flag" :src="'static/img/flag/flag_japan.png'" alt="">日本語 <small>{{$t('transLanguage.ja')}}</small></b-button>
              <b-button @click="changeLanguage('en')"><img class="flag" :src="'static/img/flag/flag_usa.png'" alt="">English <small>{{$t('transLanguage.en')}}</small></b-button>
              <b-button @click="changeLanguage('zh_tr')"><img  class="flag" :src="'static/img/flag/flag_china.png'" alt="">繁體中文 <small>{{$t('transLanguage.ch')}}</small></b-button>
            </b-button-group>
            <!-- <div class="login-btnset"><button type="submit" class="btn btn-success block m-b">{{$t('loginString')}}</button></div> -->
          </form>
        </transition>
        <transition v-else name="fade">
          <div class="bg-container">
            <h2>{{$t('haveAccountStr')}}</h2>
            <span></span>
            <div @click="signUp = !signUp" class="h3 cursor">{{$t('loginString')}}</div>
          </div>
        </transition>
        </div>

        <div class="login-panel animated fadeInDown regist" :class="{'active' : !signUp}">
          <transition v-if="!signUp" name="fade">
            <form @submit.prevent="regist">
              <div class="login-logo">
                <img alt="image" class="" src="static/img/logo_nav.png" />
              </div>
              <div class="form-group text-left">
                <label class="control-label">{{$t('idLabel')}}</label>
                <input type="text" v-model="email" class="form-control" :placeholder="$t('placeholderMailString')">
              </div>
              <div class="form-group text-left">
                <label class="control-label">{{$t('placeholderPasswordString')}}</label>
                <input type="password" v-model="password" class="form-control" :placeholder="$t('placeholderPasswordString')">
              </div>
              <div class="login-btnset"><button type="submit" class="btn btn-success block m-b" :disabled="checkRegistering">{{$t('signUpString')}}</button></div>
              <b-button-group>
                <b-button @click="changeLanguage('ja')" :disabled="checkRegistering"><img class="flag" :src="'static/img/flag/flag_japan.png'" alt="">日本語 <small>{{$t('transLanguage.ja')}}</small></b-button>
                <b-button @click="changeLanguage('en')" :disabled="checkRegistering"><img class="flag" :src="'static/img/flag/flag_usa.png'" alt="">English <small>{{$t('transLanguage.en')}}</small></b-button>
                <b-button @click="changeLanguage('zh_tr')" :disabled="checkRegistering"><img  class="flag" :src="'static/img/flag/flag_china.png'" alt="">繁體中文 <small>{{$t('transLanguage.ch')}}</small></b-button>
            </b-button-group>
            </form>
          </transition>
          <transition v-else name="fade">
            <div class="bg-container">
              <h2>{{$t('notHaveAccountStr')}}</h2>
              <span>{{$t('startedStr')}}</span>
              <div @click="signUp = !signUp" class="h3 cursor">{{$t('signUpString')}}</div>
            </div>
          </transition>
        </div>
      </div>
      <div>
        <div class="login-appversion animated fadeInDown">1on1navi for {{checkCompanyName}}<br>{{checkAppVersion}}</div>
  </div>
  </div>
</template>

<script>

import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import TransLangDropdown from './Header/TransLangDropdown.vue'
import { transLanguage, i18n, routePath } from '@/main.js'
import { settings, about } from '@/main'

function passwordValidation () {
  // let regex = new RegExp(/^([a-zA-Z0-9]{6,})$/)
  let regex = new RegExp(/^(.{6,})$/)
  if (regex.test(this.password)) {
    return true
  } else {
    return false
  }
}

export default {
  name: 'Login',
  mixedins: [validationMixin],
  components: {
    TransLangDropdown
  },
  data () {
    const $t = this.$t
    return {
      authType: settings.authType,
      loginURL: settings.adfsLoginURL,
      email: '',
      password: '',
      loginTab: $t('loginString'),
      registTab: $t('signUpString'),
      signUp: true,
      adfshantei: true,
      isRegistering: false
    }
  },
  validations: {
    email: {
      required,
      email
    },
    password: {
      required,
      passwordValidation
    }
  },
  computed: {
    checkRegistering () {
      return this.isRegistering
    },
    checkCompanyName () {
      if (about && about.companyName) return about.companyName
      else return ''
    },
    checkAppVersion () {
      if (about && about.appVersion) return about.appVersion
      else return ''
    },
    checkLanguage () {
      return i18n.locale
    }
  },
  methods: {
    changeLanguage: function (locale) {
      transLanguage(locale)
      try {
        if (window.localStorage) {
          localStorage.setItem('language', locale)
        } else {
          // alert('言語切り替えをするには、ブラウザ設定でLocalStorageを有効にする必要があります')
        }
      } catch (e) {
        // alert('言語切り替えをするには、ブラウザ設定でLocalStorageを有効にする必要があります')
        console.log('storage error::', e)
      }
    },
    onClickTab: function () {
      this.email = ''
      this.password = ''
      console.log('clixk!!')
    },
    login: function () {
      const $t = this.$t
      if (!this.$v.email.required) {
        this.$swal({
          title: $t('noEmailStr'),
          type: 'warning',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 3000
        })
      } else if (!this.$v.password.required) {
        this.$swal({
          title: $t('notPasswordString'),
          type: 'warning',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 3000
        })
      } else if (!this.$v.email.email) {
        this.$swal({
          title: $t('notEmailStr'),
          type: 'warning',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 4000
        })
      } else if (this.$v.email.required && this.$v.password.required && this.$v.email.email) {
        console.log('signIn:', this.email, this.password)
        this.$firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(
          (user) => {
            this.$firebase.auth().currentUser.getIdTokenResult().then(
              (idTokenResult) => {
                console.log('idTokenResult:', idTokenResult)
                if (idTokenResult ? (idTokenResult.claims ? idTokenResult.claims.unavailable : false) : false) {
                  console.log('Login.vue: idTokenResult unavailable')
                  this.$swal({
                    title: $t('noticeUnavailable'),
                    type: 'warning'
                  }).then(() => {
                    this.$firebase.auth().signOut().then(
                      this.$router.replace({ name: 'Login' })
                    )
                  })
                } else {
                  this.$router.replace({ name: routePath })
                }
              }
            )
            // this.$router.replace({ name: 'okr' })
          },
          (err) => {
            if (err.code === 'auth/invalid-email') {
              this.$swal({
                title: $t('notEmailStr'),
                type: 'warning',
                animation: false,
                customClass: 'animated fadeInUp',
                // customClass: 'animated flipInX',
                width: '35rem',
                position: 'center',
                // toast: true,
                padding: '2rem',
                timer: 3000
              })
            } else {
              this.$swal({
                title: this.$t('incorrectInputMessageString'),
                type: 'warning',
                animation: false,
                customClass: 'animated fadeInUp',
                // customClass: 'animated flipInX',
                width: '35rem',
                position: 'center',
                // toast: true,
                padding: '2rem',
                timer: 4000
              })
            }
          }
        )
      } else {
        this.$swal({
          title: this.$t('incorrectInputMessageString'),
          type: 'warning',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 4000
        })
      }
    },
    regist: function () {
      this.isRegistering = true
      // console.log('login=' + email, password)
      const $router = this.$router
      const $swal = this.$swal
      const $t = this.$t
      console.log('RegistUser: Password', this.password)
      if (!this.$v.email.required) {
        this.isRegistering = false
        $swal({
          title: $t('noEmailStr'),
          type: 'warning',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 3000
        })
      } else if (!this.$v.password.required) {
        this.isRegistering = false
        $swal({
          title: $t('notPasswordString'),
          type: 'warning',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 3000
        })
      } else if (!this.$v.email.email) {
        this.isRegistering = false
        $swal({
          title: $t('notEmailStr'),
          type: 'warning',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 4000
        })
      } else if (!this.$v.password.passwordValidation) {
        this.isRegistering = false
        $swal({
          title: $t('leastCharMessageStringWeb'),
          type: 'warning',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 4000
        })
      } else if (this.$v.email.required && this.$v.password.required && this.$v.password.passwordValidation) {
        console.log('regist: validation OK.')
        let chkEmail = { email: this.email }
        console.log('chkEmail', chkEmail)
        const checkRegisterableEmail = this.$firebase.functions().httpsCallable('checkUserEmail')
        checkRegisterableEmail(chkEmail).then(val => {
          console.log('checkUserEmail:', val)
          if (val && val.data && val.data.status === 'ok') {
            console.log('return to reserved:', val.data.registerable)
            return val.data.registerable || false
          } else {
            this.isRegistering = false
            $swal({
              title: $t('Server Error.\nPlease Try Again Later.'),
              type: 'warning'
            })
          }
          return false
        }).then(reserved => {
          console.log('reserved: ', reserved)
          if (reserved) {
            this.$firebase.auth().createUserWithEmailAndPassword(this.email, this.password)
              .then(user => {
                if (user) {
                  $router.replace({
                    name: 'ProfileRegist',
                    params: { regist: true, userEmail: user.email }
                  })
                  this.isRegistering = false
                }
              })
              .catch(error => {
                var errorCode = error.code
                var errorMessage = error.message
                console.log('errorCode:', errorCode)
                console.log('errorMessage:', errorMessage)
                if (errorCode === 'auth/invalid-email') {
                  this.isRegistering = false
                  $swal({
                    title: $t('notEmailStr'),
                    type: 'warning',
                    animation: false,
                    customClass: 'animated fadeInUp',
                    // customClass: 'animated flipInX',
                    width: '35rem',
                    position: 'center',
                    // toast: true,
                    padding: '2rem',
                    timer: 3000
                  })
                } else if (errorCode === 'auth/email-already-in-use') {
                  this.isRegistering = false
                  $swal({
                    title: $t('alReadyMessageString'),
                    type: 'warning',
                    animation: false,
                    customClass: 'animated fadeInUp',
                    // customClass: 'animated flipInX',
                    width: '35rem',
                    position: 'center',
                    // toast: true,
                    padding: '2rem',
                    timer: 3000
                  })
                } else if (errorCode === 'auth/weak-password') {
                  this.isRegistering = false
                  $swal({
                    title: $t('leastCharMessageStringWeb'),
                    type: 'warning',
                    animation: false,
                    customClass: 'animated fadeInUp',
                    // customClass: 'animated flipInX',
                    width: '35rem',
                    position: 'center',
                    // toast: true,
                    padding: '2rem',
                    timer: 4000
                  })
                }
              })
          } else {
            console.log('Login.vue: reserved else')
            this.isRegistering = false
            $swal({
              title: $t('noticeUnavailable'),
              type: 'warning'
            })
          }
        })
      } else {
        this.isRegistering = false
        this.$swal({
          title: this.$t('incorrectInputMessageString'),
          type: 'warning',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 4000
        })
      }
    },
    loginByIdp () {
      switch (settings.authType) {
        case 'adfs':
          let loginURL = settings.adfsLoginURL
          if (loginURL) {
            location.href = loginURL
          }
          break
        default:
          break
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit SCSS to this component only -->
<style scoped>
#tab .tab-content {
  border: 1px solid #a4b7c1 !important;
}
.nav-link {
  padding: 1rem 3rem !important;
}
.login-wrap {
  margin: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translateY(-50%) translateX(-50%);
  transform: translateY(-50%) translateX(-50%);
}
.signup-box{
  height: 70vh;
  width: 80vw;
  max-width: 940px;
  min-width: 650px;
  max-height: 500px;
  min-height: 480px;
  margin: auto;
}
.login-panel {
  width: 40%;
  height: 90%;
  margin: auto;
  color: #fff;
  background-color: #3e8fe0;
  transition: all 0.2s ease-in-out ;
}
.login-panel label {
  color: #0c2636;
}
.login-panel .bg-container h2 {
  font-size: 2.2rem;
  word-break: break-word;
  margin-top: 8rem;
  margin-bottom: 2rem;
  font-weight: 600;
  letter-spacing: 2px;
  word-spacing: 2px;
}
.login-panel .bg-container span {
  margin-bottom: 5rem;
  display: block;
  word-break: break-word;
}
.login-panel .bg-container .h3 {
  /* position: relative;
  top: 10rem; */
  width: 20rem;
  margin: 0 auto;
  color: #3e8fe0;
  font-size: 1.6rem;
  font-weight: 600;
  padding: 1rem;
  border-radius: 200px;
  background-color: #fff;
  text-align: center;
}
.login-panel form div {
  transition: all 0.2s ease-in-out ;
}
.login-panel.active {
  width: 60%;
  height: 100%;
}
.login-panel.login {
  border-radius: 4px 0 0 4px;
}
.login-panel.regist {
  border-radius: 0 4px 4px 0;
}
.login-panel.login.active,.login-panel.regist.active {
  border-radius: 6px;
  background-color: #fff;
}
.login-logo{
  margin-bottom: 6rem;
}
.login-btnset {
  /* position: absolute; */
  /* bottom: 20%; */
  /* bottom: 15%; */
  /* left: 50%; */
  /* right: 50%; */
}
.fade-enter-active, .fade-leave-active {
  transition: all 0.2s ease-in-out ;
}
.fade-leave-to {
  opacity: 0;
  display: none;
}
.fade-enter {
  /* transform: translateY(-50px); */
  opacity: 0;
}
/* for version */
.login-appversion {
  margin: 0 auto;
  text-align: center;
  position: relative;
  top: 3rem;
}
img.flag {
  width: 2rem;
}
.btn-group {
  display: flex;
  justify-content: space-around;
  display: flex;
  justify-content: space-around;
  margin-top: 3rem;
}
 /* for adfs */
.signup-box.adfs{
  max-width: 800px;
  min-width: 650px;
  max-height: 300px;
  min-height: 250px;
}
.adfs .login-logo {
  width: 260px;
}
.adfs .login-btnset {
  bottom: 20%;
}
.adfs  .login-btnset .btn {
  font-size: 2.0rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue